import { useState } from "react";
import clsx from "clsx";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import styles from "./styles.module.scss";

const ICON_BY_KIND = {
  warning: WarningAmberRoundedIcon,
  success: CheckCircleOutlineRoundedIcon,
  challenge: EmojiEventsOutlinedIcon,
  institution: SchoolOutlinedIcon,
  post: ChatBubbleOutlineRoundedIcon,
  network: PersonAddAltRoundedIcon,
  general: NotificationsNoneRoundedIcon,
};

const WRAPPER_BY_KIND = {
  warning: styles.iconWrapperWarning,
  success: styles.iconWrapperSuccess,
  challenge: styles.iconWrapperChallenge,
  institution: styles.iconWrapperInstitution,
  post: styles.iconWrapperPost,
};

export function NotificationAvatar({
  avatar,
  icon,
  kind = "general",
  seed = "",
  alt = "",
}) {
  const [failedAvatarUrl, setFailedAvatarUrl] = useState("");
  const [failedIconUrl, setFailedIconUrl] = useState("");
  const visibleAvatar = avatar && avatar !== failedAvatarUrl ? avatar : "";
  const visibleIcon = icon && icon !== failedIconUrl ? icon : "";

  if (visibleAvatar) {
    return (
      <img
        src={visibleAvatar}
        alt={alt || seed}
        className={styles.avatar}
        onError={() => setFailedAvatarUrl(visibleAvatar)}
      />
    );
  }

  if (!visibleIcon && (kind === "network" || kind === "institution")) {
    return (
      <div
        className={styles.avatarFallback}
        role="img"
        aria-label={alt || seed || "User avatar"}
      >
        <PersonRoundedIcon className={styles.avatarFallbackIcon} />
      </div>
    );
  }

  if (visibleIcon) {
    return (
      <div
        className={clsx(
          styles.iconWrapper,
          WRAPPER_BY_KIND[kind],
        )}
      >
        <img
          src={visibleIcon}
          alt={alt || seed}
          className={styles.iconImg}
          onError={() => setFailedIconUrl(visibleIcon)}
        />
      </div>
    );
  }

  const Glyph = ICON_BY_KIND[kind] || ICON_BY_KIND.general;

  return (
    <div
      className={clsx(
        styles.iconWrapper,
        WRAPPER_BY_KIND[kind],
      )}
    >
      <Glyph className={styles.iconGlyph} />
    </div>
  );
}
